export const BRAND = {
    PORTAL_NAME: 'fujifilm-packet',
    NAME: 'Fujifilm Packet',
    LOGO: '/images/brand/Fujifilm_Logo_Alternative_0.svg',
    LOGO_LINK: '',
    LOGIN_BG_IMAGE: '',
    SUPPORT_EMAIL: '',
    MARKET_SITE: 'Fujifilm',
};

export const SocketEnds = {
    SOCKET_TOKEN: '/v1/socket-token',
};

export const RestEnds = {
    // Authentication
    LOGIN: '/v1/login',
    LOGIN_AAD: '/v1/aad-login',
    REGISTER: '/v1/register',
    FORGOT_PASSWORD: '/v1/forget-password',
    RESEND_EMAIL: '/v1/resend-email',
    RESET_PASSWORD: '/v1/reset-password',
    VERIFY_EMAIL: '/v1/verify-email',
    LOGOUT: '/v1/logout',
    REFRESH_TOKEN: '/v1/token',
    SECURITY_VERIFICATION: '/v1/2fa/verify',

    // User Settings
    SETUP_2FA: '/v1/2fa/setup',
    CONFIRM_TWO_FA: '/v1/2fa/confirmation',
    RESET_TWO_FA: '/v1/2fa/reset',
    TOGGLE_TWO_FA: '/v1/2fa/config',

    // Profile
    PROFILE: '/v1/profile',
    EDIT_PROFILE: '/v1/edit-profile',
    CHANGE_PASSWORD: '/v1/change-password',

    // ShareMember
};

export const UpPacketEnd = {
    UPLOAD_HISTORY: 'v1/upload-history',
    UPLOAD: 'v1/upload',
    SIGNED_RESOURCE: 'v1/signed-url',
};

export const ClientEnd = {
    // Upload Packets
    ADD_CLIENT: 'v1/client',
    GET_CLIENT: 'v1/client',
    GET_CLIENT_LIST: 'v1/clients',
    GET_CLIENT_ENABLED: 'v1/getEnabledClient',
    GET_CLIENT_AUDIT: 'v1/client-audit',
    EDIT_CLIENT: 'v1/editClient',
    GET_SOLICITOR: 'v1/getSolicitors',
    REPLACE_CLIENT_CHECKLIST: 'v1/replace-checklist',
    TOGGLE_CLIENT_CHECKLIST_STEP: 'v1/toggle-checklist',
    REVIEW_HIDE_CHECK: 'v1/review/hide-check',
};
export const TemplateEnd = {
    // Upload Packets
    SAVE_TEMPLATE: 'v1/template',
    GET_TEMPLATE: 'v1/template',
    DELETE_TEMPLATE: 'v1/template',
    PATCH_TEMPLATE_DASHBOARD: 'v1/user/dashboard',
    SHARE_TEMPLATE: 'v1/shared-template',
    GET_MEMBERS: 'v1/members',
    SHARE_TEMPLATE_INVITE: 'v1/shareTemplate',
    SHARED_TEMPLATE: 'v1/shared-template',
    SAVE_GLOBALLY_TEMPLATE: 'v1/global-template',
    RESET_GLOBALLY_TEMPLATE: 'v1/reset/global-template',
    RESET_CUSTOM_TEMPLATE: 'v1/reset/custom-template',
    SAVED_TEMPLATE: 'v1/save-template',
    RESET_TEMPLATE: 'v1/reset-template',
};

export const UpPacketReworkEnd = {
    GET_REWORK: 'v1/rework',
    UPLOAD_REWORK: 'v1/rework',
    SIGNED_REWORK_RESOURCE: 'v1/rework/signed-url',
};

export const ManagePacketEnd = {
    GET_PACKETS: 'v1/getPackets',
    GET_REPORT_VERTICES: 'v1/reportVertices',
    GET_PACKET: 'v1/getPacket',
    GET_PACKETS_AUDIT: 'v1/packet-audit',
    rerun_VALIDATION: 'v1/rerunValidation',
    rerun_PACKET: 'v1/rerunPacket',
    rerun_DUPLICATE: 'v1/rerun-docDuplicate',
    rerun_GROUPING: 'v1/rerunGrouping',
    GET_CATEGORY: 'v1/getCategory',
    GET_SASTOKEN: 'v1/getSastoken',
    UPDATE_CATEGORY: 'v1/updateCategory',
    MOVE_CATEGORY: 'v1/moveToCategorization',
    UPDATE_GROUPING: 'v1/updateGrouping',
    MOVE_TO_CM9: 'v1/moveToCm9',
    SEND_TO_REWORK: 'v1/sentForRework',
    GET_REVIEW: 'v1/getReview',
    REVIEW_PACKET: 'v1/reviewPacket',
    REVIEW_REPORT: 'v1/reportReview',
    OPS_ACTION: 'v1/operatorAction',
    HIGHLIGHT_ACTION: 'v1/highlight',
    DELETE_PACKET: 'v1/packet',
    REPLACE_DOCUMENT: 'v1/replaceDocument',
};

export const ManageAccessEnd = {
    GET_MEMBERS: 'v1/members',
    GET_ROLES: 'v1/roles',
    SEND_INV_MEMBERS: 'v1/member',
    PATCH_MEMBER: 'v1/member',
    PATCH_MEMBER_CONFIG: 'v1/member/config',
    DELETE_MEMBER: 'v1/member',
    GET_MEMBERS_AUDIT_FILE: 'v1/user-audit',
};
